import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";

import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Products } from "@/components/site/Products";
import { Dimensions } from "@/components/site/Dimensions";
import { Technology } from "@/components/site/Technology";
import { Marquee } from "@/components/site/Marquee";
import { Manufacturing } from "@/components/site/Manufacturing";
import { Growth } from "@/components/site/Growth";
import { DealerNetwork } from "@/components/site/DealerNetwork";
import { Gallery } from "@/components/site/Gallery";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div
      className="min-h-screen text-avatar-ink antialiased"
      style={{ background: "linear-gradient(180deg, #F2F7FC 0%, #E6EEF7 48%, #F2F7FC 100%)" }}
    >
      <Toaster position="bottom-right" theme="light" richColors />
      <Nav />
      <main>
        <Hero />
        <Growth />
        <About />
        <Products />
        <Dimensions />
        <Technology />
        <Marquee />
        <Manufacturing />
        <DealerNetwork />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
